import * as Preact from 'preact';
import { icons } from '@dora/components';
import { SxProps } from '@mui/system';
import { sizing, Fab } from '@dora/components';
import { Zoom } from '@mui/material';

export interface Props {
    onAddClick: () => void;
    sx?: SxProps;
    show: boolean;
}

export const Component = (p: Props) => {
    return (
        <Zoom in={p.show} appear={false} unmountOnExit>
            <Fab.Component
                variant="circular"
                color="primary"
                size="medium"
                onClick={p.onAddClick}
                sx={{
                    position: 'absolute',
                    bottom: sizing.fabPadding.desktopY,
                    right: sizing.fabPadding.desktopX,
                }}
            >
                <icons.AddIcon />
            </Fab.Component>
        </Zoom>
    );
};
